export const SENDBIRD_CHANNEL_TYPES = {
  BUYER_SELLER: "Buyer-Seller",
  LETTER: "Letter",
  BUYER_BROKER: "Buyer-Broker",
  SELLER_BROKER: "Seller-Broker",
  CLAIM: "Claim",
};

export type CustomChannelType = typeof SENDBIRD_CHANNEL_TYPES;

export type ChannelType = {
  id: number;
  name: string;
  home_id: number;
  owner_messaged: boolean;
  broker_messaged: boolean;
  speculant_messaged: boolean;
  created_at: Date;
};

export type ChannelParams = {
  user_ids: string[];
  name: string;
  channel_url?: string;
  cover_url: string | undefined;
  custom_type: string;
  data: string;
  is_distinct: boolean;
  inviter_id: string;
  operator_ids: string[];
};

export type ChannelMetadataProps = {
  home_id: number;
  buyer_ids?: string[];
  seller_ids?: string[];
  existing_owner_ids?: string[];
};

// export type SendbirdMetadata = {
//   homeId: string;
//   ownerIds: string[];
//   speculantIds: string[];
//   brokerIds: string[];
//   ownerMessaged: boolean;
//   speculantMessaged: boolean;
//   brokerMessaged: boolean;
// };

// export type SendbirdMetadataStrings = {
//   homeId: string;
//   ownerIds: string;
//   speculantIds: string;
//   brokerIds: string;
//   ownerMessaged: string;
//   speculantMessaged: string;
//   brokerMessaged: string;
// };

// export type ConversationType = SendbirdMetadata & {
//   customType: CustomChannelType;
//   id: string; // channelUrl in Sendbird
// };
